<template>
<div sidebar="compact" bottomnav>
    <PendoTracker v-if="shouldLoadPendoTracker" />
    <router-view />
</div>
</template>

<script>
// import JQuery from 'jquery'
import PendoTracker from '@/components/Pendo/PendoTracker.vue';
import * as Dropzone from "dropzone";    
export default {
  name: "App",
  components: {
    PendoTracker
  },
  computed: {
    shouldLoadPendoTracker() {
      // Don't load PendoTracker for standalone external routes to avoid profile API calls
      const route = this.$route;
      const isStandaloneExternal = route.params.standalone === 'standalone' && route.params.external === 'external';
      const isStandaloneExternalByPath = route.path && route.path.includes('/standalone/external/');
      const shouldSkip = isStandaloneExternal || isStandaloneExternalByPath;
      
      // Debug logging for troubleshooting
      console.log('App.vue Debug - Route params:', route.params);
      console.log('App.vue Debug - Route path:', route.path);
      console.log('App.vue Debug - Should skip PendoTracker:', shouldSkip);
      console.log('App.vue Debug - Should load PendoTracker:', !shouldSkip);
      
      return !shouldSkip;
    }
  },
  methods: {
    isStandaloneExternalRoute() {
      const route = this.$route;
      const isStandaloneExternal = route.params.standalone === 'standalone' && route.params.external === 'external';
      const isStandaloneExternalByPath = route.path && route.path.includes('/standalone/external/');
      return isStandaloneExternal || isStandaloneExternalByPath;
    }
  },
  watch: {
    '$route'(to, from) {
      // Watch for route changes to debug PendoTracker loading
      console.log('App.vue - Route changed from:', from.path, 'to:', to.path);
      console.log('App.vue - New route params:', to.params);
    }
  },
  mounted() {
    // window.$ = JQuery;
    window.Dropzone = Dropzone
    },  
    methods: {
    }
};
</script >

<style>
@import "./assets/css/styles.css";
@import "./assets/css/spritesmith-generated/sprite.css";
</style>
